import { render, staticRenderFns } from "./StandingTable.vue?vue&type=template&id=093ab796&lang=pug"
import script from "./StandingTable.vue?vue&type=script&lang=js"
export * from "./StandingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports